const API_BASE_URL = 'https://api.realitni-jestrab.cz'

export const publicPropertyDemoService = {
  async fetch(propertyId) {
    const response = await window.fetch(`${API_BASE_URL}/api/property-demos/${encodeURIComponent(propertyId)}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })

    if (!response.ok) {
      throw new Error(response.status === 404 ? 'Ukázková analýza nebyla nalezena' : 'Ukázkovou analýzu se nepodařilo načíst')
    }

    return response.json()
  },
}
